
import axios from 'axios';
import { useEffect, useState, useRef, useContext } from 'react';
import { RoomContext,TrackToggle } from '@livekit/components-react';
import { Room } from 'livekit-client';
import { useTracks, RoomAudioRenderer, useTranscriptions } from "@livekit/components-react";
import { VideoTrack } from '@livekit/components-react';
import { Track } from 'livekit-client';
import '@livekit/components-styles';
import { Button, Container, Row, Col, Card, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocation } from "react-router-dom";
import { AppContext } from '../App';
import { useTrackToggle } from '@livekit/components-react';
import "bootstrap-icons/font/bootstrap-icons.css";


function CityVideoRenderer({ agentName, onStop, loading }) {
    const [isZoom, setIsZoom] = useState(false);
    const trackRefs = useTracks([Track.Source.Camera]);
    const camTrackRef = trackRefs.find(
        (trackRef) => trackRef.participant.name === agentName
    );

    if (!camTrackRef) {
        return (
            <div className="loader">
                <img src="/loader2.gif" alt="loading..." width="250" />
            </div>
        );
    }

    // Normal View
    if (!isZoom) {
        return (
            <div className="video-wrapper position-relative">
                <VideoTrack
                    trackRef={camTrackRef}
                    className='video-el'
                />
                <RoomAudioRenderer />
                <button className="zoom-btn" onClick={() => setIsZoom(true)}><i className="bi bi-arrows-angle-expand fs-4"></i></button>
            </div>
        );
    }

    // Zoom View
    return (
        <div className="video-zoom-overlay">

            <button className="zoom-close-btn" onClick={() => setIsZoom(false)}> ✕ </button>

            <div className="zoom-controls" style={{ maxWidth: "700px" }}>
                <div className="d-flex align-items-center">
                    <TrackToggle className='bg-light py-3 rounded-circle d-flex align-items-center justify-content-center shadow text-dark' source={Track.Source.Microphone} />
                </div>
                <PauseButton variant='zoom-screen-pause-btn' />
                <Button className='zoom-screen-stop-btn rounded-circle d-flex align-items-center justify-content-center shadow text-light' variant="danger" onClick={onStop} disabled={loading}><i className='bi bi-telephone-x-fill fs-6' /></Button>
            </div>

            <VideoTrack trackRef={camTrackRef} className="zoom-video" />
            <RoomAudioRenderer />
        </div>
    );
}

function ChatBox() {
    const transcriptions = useTranscriptions();
    const boxRef = useRef(null);

    useEffect(() => {
        if (boxRef.current) {
            boxRef.current.scrollTop = boxRef.current.scrollHeight;
        }
    }, [transcriptions]);

    return (
        <div className="p-3 m-2 shadow-sm rounded chat-box" ref={boxRef}>
            {transcriptions.map((transcription) =>
                <div
                    style={{
                        display: "flex",
                        justifyContent: transcription.participantInfo.identity.includes("agent")
                            ? "flex-start"
                            : "flex-end",
                        marginBottom: "10px",
                    }}
                >
                    <div className='text-start'
                        style={{
                            maxWidth: "70%",
                            padding: "10px 14px",
                            borderRadius: "12px",
                            background: transcription.participantInfo.identity.includes("agent")
                                ? "#5f0082ff" : "#ffffffff",
                            color: transcription.participantInfo.identity.includes("agent") ? "#ffffff" : "#333",
                            fontSize: "14px",
                            lineHeight: "1.4",
                        }}
                    >
                        <strong>
                            {transcription.participantInfo.identity.includes("agent") ? "Agent" : "You"}:
                        </strong>{" "}
                        {transcription.text}
                    </div>
                </div>
            )}
        </div>
    );
}

const PauseButton = ({ variant }) => {

    const { buttonProps, enabled } = useTrackToggle({
        source: Track.Source.Microphone,
        initialState: true
    });

    return (
        <Button variant='dark' onClick={buttonProps.onClick} className={`rounded-circle d-flex align-items-center justify-content-center shadow ${variant ? variant : 'pause-btn'}`}>
            <i className={`bi ${enabled ? "bi-pause-fill" : "bi-play-fill"}`} />
        </Button>
    );
};

function AgentConfig({ configData }) {
    return (
        <Card className={`p-md-3 m-md-2 shadow-sm`}>
            <Card.Body>
                <div className="mb-3 text-start">
                    <strong>Agent Name:</strong><div className="p-2 bg-light rounded mt-1 text-start">{configData.agentName}</div>
                </div>

                <div className="mb-3 text-start">
                    <strong>Instructions/Prompt:</strong>
                    <div
                        className="p-2 bg-light rounded mt-1"
                        style={{ maxHeight: "150px", overflowY: "auto" }}
                    >
                        {configData.instructions}
                    </div>
                </div>

                <div className='text-start'>
                    <strong>First Message:</strong>
                    <div
                        className="p-2 bg-light rounded mt-1 text-start"
                        style={{ maxHeight: "150px", overflowY: "auto" }}
                    >
                        {configData.firstMessage}
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
}


function Demo({ isConfigurationLoading }) {
    axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;  // server url
    const location = useLocation();
    const [room] = useState(() => new Room({}));
    const { configData, setConfigData, configList, handleConfigChange, loading, setLoading, getConfiguration } = useContext(AppContext);
    const [isStartConversation, setIsStartConversation] = useState(null);
    const agentName = process.env.REACT_APP_LOCAL_AGENT;
    const [roomName, setRoomName] = useState(null);

    function getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min) + min);
    }

    const connect = () => {
        setIsStartConversation(true);
        //create room
        const roomName = `testroom-${getRandomInt(1000, 9999)}`;
        setRoomName(roomName);
        const participantName = 'You';
        console.log('Room Name:', roomName, 'Participant Name:', participantName);
        createRoom(roomName, participantName);
        createAgentSession(roomName, agentName);
        trackUser(roomName, configData.id); // track user activity
    }

    async function createRoom(roomName, participantName) {
        const result = await axios.get(`/getLivekitToken/${roomName}/${participantName}`)
        console.log('Livekit token', result.data);
        room.connect(process.env.REACT_APP_LIVEKIT_URL, result.data);
    }

    async function trackUser(roomName, configId) {
        try {
            // Get IP from public API
            const ipRes = await axios.get('https://api.ipify.org?format=json');
            const ip = ipRes.data.ip;
            await axios.post('/track_user', {
                ip: ip,
                room_name: roomName,
                config_id: configId,
                agent_name: agentName
            });
        } catch (error) {
            console.error("Error tracking user:", error);
            // Server detect from request
            try {
                await axios.post('/track_user', {
                    room_name: roomName,
                    config_id: configId,
                    agent_name: agentName
                });
            } catch (e) {
                console.error("Error sending fallback tracking:", e);
            }
        }
    }

    async function createAgentSession(roomName, agent) {
        setLoading('agent-starting');
        console.log('Creating session for agent:', agent);

        // Build metadata from configData so agent.py gets full config at dispatch time
        const metadata = {
            config_name: configData.name,
            instructions: configData.instructions,
            first_message: configData.firstMessage,
            avatar_face_id: configData.avatar?.faceId,
            avatar_provider: configData.avatar?.provider,
            avatar_name: configData.avatar?.name,
            voice_id: configData.voice?.voiceId,
            voice_model: configData.voice?.model,
            voice_type: configData.voice?.voiceType,
            voice_name: configData.voice?.name
        };
        try {
            const result = await axios.post("/dispatch_agent", {agentName:agent, roomName:roomName, metadata}, { headers: { "Content-Type": "application/json" } });
            console.log('Agent dispatched with metadata:', result.data);
        }
        catch (error) {
            console.log("Error occurred at creating agent: ", error)
        }
        finally {
            setLoading('')
            console.log("Agent session create.");
        }
    }

    async function stopagentsession() {
        setLoading('agent-stopping');
        setIsStartConversation(false);
        try {
            room.disconnect();
            const result = await axios.post("/stop_agent_session", { "room_name": roomName })
        }
        catch (error) {
            console.log("Error occurred during stop agent:", error)
        }
        finally {
            setLoading('')
            console.log("Agent session stopped.");
        }
    }

    return (<>
        <Container fluid className="p-2 pt-md-3 pb-md-0 px-lg-5">
            <RoomContext.Provider data-lk-theme="default" value={room}>
                <Row className='mx-auto'>
                    <Col lg={5} className={`mx-auto px-0 ${isStartConversation ? '' : 'order-2 order-lg-1'}`}>
                        {isStartConversation ?
                            (<div className="p-3 video-room align-items-center">
                                <CityVideoRenderer agentName={agentName} onStop={stopagentsession} loading={loading} />
                                <div className="controls" style={{ maxWidth: "700px" }}>
                                    <div className="d-flex align-items-center">
                                        <TrackToggle className='control-btn rounded-circle mute-btn' source={Track.Source.Microphone} />
                                    </div>
                                    <PauseButton />
                                    <Button className='control-btn rounded-circle text-light text-center position-relative' variant="danger" onClick={stopagentsession} disabled={loading}><i className='bi bi-telephone-x-fill fs-6 position-absolute top-50 start-50 translate-middle' /></Button>
                                </div>
                            </div>)
                            :
                            (<Card className="m-md-3 pe-lg-5 pb-2" style={{ border: "none" }}>
                                <Card.Body>
                                    {isConfigurationLoading ?
                                        <div className="loader"><img src="/loader2.gif" alt="loading..." width="250" /></div>
                                        : <Card.Img className="mt-4 mt-md-0" src={configData?.avatar?.preview} alt="Avatar Preview" style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: "8px" }} />}
                                </Card.Body>
                                <Card.Footer className='bg-white border-0'>
                                    <Button variant="success" onClick={connect} className="px-5 fw-bold" disabled={loading === 'agent-stopping'}>Start</Button>
                                    <div className={`text-center py-1 ${loading === 'agent-stopping' ? '' : 'invisible'}`}>Closing the session, please wait...</div>
                                </Card.Footer>
                            </Card>)}
                    </Col>

                    <Col lg={7} className={`mx-auto px-2 ${isStartConversation ? '' : 'order-1 order-lg-2 py-3'}`}>
                        {isStartConversation ?
                            <ChatBox />
                            : (<>
                                <Form.Group className="mb-3 text-start">
                                    <Form.Label>Select Configuration:</Form.Label>
                                    <Form.Select
                                        value={configData?.id}
                                        onChange={handleConfigChange}>
                                        {configList?.map((config) => (
                                            <option key={config.id} value={config.id} hidden={config.id === configData?.id}>
                                                {config.name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                                {isConfigurationLoading ? <div className="loader"><img src="/loader2.gif" alt="loading..." width="250" /></div> : <AgentConfig configData={configData} loading={loading} />}
                            </>)}
                    </Col>
                </Row>
            </RoomContext.Provider>
        </Container>
    </>)
}

export default Demo;